// CustomTooltip.js
import React from "react";

export default function CustomTooltipCrg({ active, payload, label }) {
  if (active && payload && payload.length) {
    const severityLabels = {
      1: "No",
      2: "Yes",
    };

    return (
      <div
        style={{
          backgroundColor: "#f5f5f5",
          border: "1px solid #ccc",
          borderRadius: "8px",
          padding: "10px 14px",
          fontSize: "14px",
          fontWeight: "bold",
          color: "#333",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <div
          style={{
            borderBottom: "1px solid #ddd",
            marginBottom: "6px",
            paddingBottom: "4px",
          }}
        >
          {label}
        </div>
        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
          {payload.map((item, idx) => (
            <li
              key={idx}
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "4px",
              }}
            >
              <div
                style={{
                  width: 10,
                  height: 10,
                  backgroundColor: item.color,
                  marginRight: 8,
                  borderRadius: "50%",
                }}
              />
              <span style={{ color: "#555", fontWeight: "normal" }}>
                {item.name}:
              </span>
              <span style={{ marginLeft: 4, color: "#000" }}>
                {severityLabels[payload[0].value] || payload[0].value}
              </span>
            </li>
          ))}
        </ul>
        {/* <p style={{ margin: 0 }}>
          Category: {severityLabels[payload[0].value] || payload[0].value}
        </p> */}
      </div>
    );
  }

  return null;
}
